import React, { useContext, useEffect, useState, useCallback } from "react";
import { withRouter } from "react-router-dom";
import { SHOPIFY_API_KEY, SHOPIFY_EMBEDDED_FORCE_REDIRECT } from "aws-exports";
import { Provider } from "@shopify/app-bridge-react";
import createApp from "@shopify/app-bridge";
import { Redirect, History, Button } from "@shopify/app-bridge/actions";
import { useRoutePropagation } from "@shopify/react-shopify-app-route-propagator";
import useReactRouter from "use-react-router";
import NotifyContext from "context/NotifyContext";
import ShopContext from "context/ShopContext";
import { ErrorScreen } from "screens";
import { parseQueryString } from "lib/query-string";
import { EmbeddedProvider } from "context/EmbeddedContext";
import UserContext from "context/UserContext";
import { ENGINE_WARNING_ICON } from "lib/globals";
import { getPlansModal } from "lib/getPlans";
import classNames from "lib/classNames";
import ChargeApproval from "./chargeApproval";
import WelcomeModal from "./welcomeModal";

const Embedded = ({ children, location, newPlanRedirect }) => {
  const { history } = useReactRouter();
  const user = useContext(UserContext);
  const shopContext = useContext(ShopContext);
  const {
    state: {
      settings,
      settingsSaved,
      chargeConfirmationUrl,
      redirectToChargeApproval,
      id,
      installedAt
      // show_recharge_alert
    },
    setItem
  } = shopContext;
  const [savedSettings, setSavedSettings] = useState(settings);
  const { createNotification, deleteNotification } = useContext(NotifyContext);
  const config = {
    apiKey: SHOPIFY_API_KEY,
    shopOrigin: user.attributes.website,
    forceRedirect: SHOPIFY_EMBEDDED_FORCE_REDIRECT
  };

  const app = createApp(config);

  const AppBridgeHistory = History.create(app);
  const AppBridgeRedirect = Redirect.create(app);
  const { search, pathname } = location;
  useRoutePropagation(app, location);
  useEffect(() => {
    if (window.$crisp) {
      window.$crisp.push(["set", "session:data", ["store", id]]);
      window.$crisp.push(["set", "session:data", ["App", "Monster UPSELLS"]]);
    }
    if (!settingsSaved || !settings.active) {
      createNotification({
        type: "warning",
        title: "Custom cart is disabled.",
        // content: 'Start by enabling the custom cart',
        icon: ENGINE_WARNING_ICON,
        action: {
          text: "Go to settings",
          onClick: () => history.push("/settings")
        },
        closeable: false,
        exclude: ["/settings", "/plan"]
      });
    }
    // if (show_recharge_alert) {
    //   createNotification({
    //     type: "info",
    //     title: "Support Recharge",
    //     content: "To support Recharge, we need to be able to write discounts.",
    //     icon: "info-circle",
    //     action: {
    //       text: "Grant Permission",
    //       onClick: () => {
    //         const shopParam = `?shop=${id}&recharge=true`;
    //         const login_url = window.location.origin + "/login" + shopParam;
    //         AppBridgeRedirect.dispatch(Redirect.Action.REMOTE, login_url);
    //       }
    //     },
    //     closeable: true
    //   });
    // }
  }, [settings]);
  // src={ `${window.location.origin}/${getPlansModal(new Date(installedAt).getTime())}?chargeConfirmationUrl=${chargeConfirmationUrl}`}
  return (
    <>
      <EmbeddedProvider value={{ app, AppBridgeRedirect, AppBridgeHistory }}>
        <Provider config={config}>
          {redirectToChargeApproval && <ChargeApproval />}
          <WelcomeModal />
          <ErrorScreen>{children}</ErrorScreen>
        </Provider>
      </EmbeddedProvider>
    </>
  );
};

export default withRouter(Embedded);
